<script setup>
import AddRoomsSection from './AddRoomsSection.vue';

const GRADES = ['Grade 1', 'Grade 2', 'Grade 3', 'Grade 4', 'Grade 5', 'Grade 6', 'Kinder 1', 'Kinder 2'];
</script>

<template>
  <AddRoomsSection :grades="GRADES" elementary />
</template>
